import { render, staticRenderFns } from "./ViewSurvey.vue?vue&type=template&id=1355b144&"
import script from "./ViewSurvey.vue?vue&type=script&lang=js&"
export * from "./ViewSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports